const demoRequests = {
  listDemoRequests: {
    list: "طلبات العرض التوضيحي",
    searchPlaceholder: "ابحث باسم الشركة",
    fromDate: "من",
    toDate: "إلى",
    details: "التفاصيل",
    name: "الاسم",
    workEmail: "البريد الإلكتروني للعمل",
    phoneNumber: "رقم الهاتف",
    companyName: "اسم الشركة",
    dateRequested: "تاريخ الطلب",
    contacted: "تم التواصل",
    actions: "الإجراءات",
    delete: "حذف",
    remove: "إزالة",
    removeTitle: "إزالة طلب العرض التوضيحي هذا؟",
    removeDescription:
      "سيؤدي هذا إلى إزالة طلب {name} نهائيًا من القائمة. لا يمكن التراجع عن هذا الإجراء.",
    removeAction: "إزالة الطلب",
    removedToastTitle: "تمت إزالة الطلب",
    removedToastBody: "تمت إزالة طلب العرض التوضيحي الخاص بـ {name} من القائمة.",
    expand: "توسيع",
    collapse: "طي",
    requestDetailsLabel: "تفاصيل الطلب:",
    showingRange: "عرض {from}-{to} من {total} طلبات",
    noDataDescription: "عذرًا، لا توجد طلبات عرض توضيحي.",
    bannerNoteLabel: "ملاحظة:",
    bannerNote:
      "هذه طلبات عرض توضيحي من صفحة الهبوط. تواصل مع هؤلاء العملاء المحتملين خارج النظام باستخدام معلومات الاتصال المقدمة. لا توجد إجراءات مطلوبة في هذه الواجهة.",
  },
};

export default demoRequests;
